import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.BTF],
  strings: ['DV_DP_unavailable_episode_list_message'] as const,
}
